// src/firebase.js
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  getToken as getAppCheckToken,
} from 'firebase/app-check';

const firebaseConfig = {
  apiKey: 'AIzaSyCudOnW9jxy3vMjatJ_zscG0xsSCbBQhIY',
  authDomain: 'admin.renterplatform.com',
  projectId: 'renter-3c444',
  storageBucket: 'renter-3c444.appspot.com',
  messagingSenderId: '247924983970',
  appId: '1:247924983970:web:3e379ce782e558db76effb',
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// ---------- App Check (npm SDK), lint-safe + HMR-safe ----------
const isBrowser = typeof window !== 'undefined';
const g = isBrowser ? window : {}; // <-- no globalThis/self

if (!g.__APP_CHECK_INIT__) {
  g.__APP_CHECK_INIT__ = true;

  try {
    const meta = isBrowser
      ? document.querySelector('meta[name="app-check-site-key"]')
      : null;
    const siteKey = (meta?.content || '').trim();

    if (!siteKey) {
      // Works only while enforcement is OFF. Log once so it’s obvious.
      // eslint-disable-next-line no-console
      console.warn('[AppCheck] No site key meta found; requests will fail when enforcement is ON.');
    } else {
      // Local dev: stable debug token so enforcement can stay ON
      if (isBrowser && window.location.hostname === 'localhost') {
        if (!window.localStorage.APP_CHECK_DEBUG) {
          window.localStorage.APP_CHECK_DEBUG = 'dev-local';
        }
        g.FIREBASE_APPCHECK_DEBUG_TOKEN = window.localStorage.APP_CHECK_DEBUG;
      }

      const appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(siteKey),
        isTokenAutoRefreshEnabled: true,
      });

      // Acquire one token up front to avoid “Missing or insufficient permissions”
      g.__APP_CHECK_INIT_PROMISE__ = getAppCheckToken(appCheck, false)
        .then(() => console.log('[AppCheck] token acquired'))
        .catch((e) => console.warn('[AppCheck] token fetch failed (continuing):', e));
    }
  } catch (e) {
    console.warn('[AppCheck] init skipped/failed:', e);
  }
}

// Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Optional: let routes/pages await the init promise if desired
export const appReady = Promise.resolve(g.__APP_CHECK_INIT_PROMISE__ ?? undefined);

export default app;
